export default __webpack_public_path__ + "static/media/joined.26f7a29e.jpg";